import {ChangeDetectionStrategy, Component, Input, OnInit} from "@angular/core";
import {FormComponent} from "./model/form-component";
import {FormControl, FormGroup} from "@angular/forms";
import * as sample from "../sample.json";
import {SESSION_COMPONENT, SESSION_DATA} from "./model/dictionary";

@Component({
    selector: "app-renderer",
    templateUrl: './app.renderer.component.html',
    styleUrls: ['app.renderer.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppRendererComponent implements OnInit {

    @Input()
    component: FormComponent;
    @Input()
    data: any
    @Input()
    formGroup: FormGroup;

    ngOnInit() {
        console.log("******************************************");
        console.log("Initializing Dynamic Component Renderer...");
        this.formGroup = new FormGroup({});
        const loadDateTime = new FormControl();
        loadDateTime.setValue(new Date().toISOString());
        this.formGroup.addControl('userLoadDate', loadDateTime);
        //load from session if exists or else load sample
        const componentFromSession = sessionStorage.getItem(SESSION_COMPONENT);
        if (componentFromSession) {
            this.component = JSON.parse(componentFromSession);
        } else {
            this.component = (sample as any).default;
        }
    }

    submitData(): void {
        console.log('Saving data');
        const submitDateTime = new FormControl();
        submitDateTime.setValue(new Date().toISOString());
        this.formGroup.addControl('userSubmitDate', submitDateTime);

        const user = new FormControl();
        user.setValue('demo_user');
        this.formGroup.addControl('username', user);

        console.log(this.formGroup.value);

        const sessionDataLog = sessionStorage.getItem(SESSION_DATA);
        const prettyJsonData = JSON.stringify(this.formGroup.value, null, 2);
        if (sessionDataLog == null) {
            sessionStorage.setItem(SESSION_DATA, prettyJsonData);
        } else {
            sessionStorage.setItem(SESSION_DATA, sessionDataLog + ',' + prettyJsonData);
        }
    }

}
